import { render, staticRenderFns } from "./associated_customer.vue?vue&type=template&id=a04cb2bc&scoped=true&"
import script from "./associated_customer.vue?vue&type=script&lang=js&"
export * from "./associated_customer.vue?vue&type=script&lang=js&"
import style0 from "./associated_customer.vue?vue&type=style&index=0&id=a04cb2bc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04cb2bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a04cb2bc')) {
      api.createRecord('a04cb2bc', component.options)
    } else {
      api.reload('a04cb2bc', component.options)
    }
    module.hot.accept("./associated_customer.vue?vue&type=template&id=a04cb2bc&scoped=true&", function () {
      api.rerender('a04cb2bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/user_management/form/associated_customer/associated_customer.vue"
export default component.exports